import React from 'react';
import BaseStep from './BaseStep';
import { ReviewTable } from './Review/ReviewTable';
import UIHelper from '../utils/UIHelper';

/**
 * Review step class.
 */
export default class ReviewStep extends BaseStep {
  static id = 'review-step';

  static title = 'Review';

  /**
   * Renders the step component.
   * @returns {JSX.Element} The step component.
   */
  render() {
    const { x, y } = this.wizardData.resolution;

    return (
      <>
        {this.renderNavigationPrompt(true)}
        <div className="review-step">
          <div className="review-summary">
            <div className="review-summary-item">
              <span className="review-summary-label">Sequence name</span>
              <span className="review-summary-value" data-test="review-sequence-name">
                {this.wizardData.name}
              </span>
            </div>
            <div className="review-summary-item">
              <span className="review-summary-label">Resolution</span>
              <span className="review-summary-value" data-test="review-sequence-resolution">
                {UIHelper.asset.formatResolution(x, y)}
              </span>
            </div>
            <div className="review-summary-item">
              <span className="review-summary-label">Campaign to Deploy</span>
              <span className="review-summary-value" data-test="review-sequence-target-campaign">
                {this.wizardData.targetCampaign.campaignName}{' '}
                {this.wizardData.targetCampaign.isActive ? '(Active)' : ''}
              </span>
            </div>
          </div>
          <ReviewTable sequence={this.wizardData.sequence} />
        </div>
      </>
    );
  }
}
